import React from "react";
import Link from "next/link";
import { handleConvertSecondsToMinutes } from "../../../../../utils/utils";

const MobileCardListing = ({ cardData, limit }) => {
  return (
    <div className="!w-full">
      {cardData?.slice(0, limit || 5)?.map((item) => {
        return (
          <Link
            href={`/video/${item?.slug}?muted=false`}
            className="no-underline"
          >
            <div
              className="flex w-full justify-between gap-x-4 first:!mt-4 mt-4"
              key={item?.id}
            >
              <div className="w-[125px]">
                <img
                  src={item?.image}
                  alt={item?.title}
                  className="!w-full rounded-lg"
                />
              </div>
              <div className="w-[85%] mx-auto">
                <h6
                  className="!text-white line-clamp-2 leading-[22px]"
                  style={{ fontFamily: "Inter" }}
                >
                  {item?.display_title}
                </h6>
                <h6 className="text-gray-400 text-[13px] font-normal flex gap-x-1 items-center mt-2">
                  {handleConvertSecondsToMinutes({ seconds: item?.duration_s })}{" "}
                  <span>•</span>
                  <span>{item?.rating}</span>
                  <span className="text-[11px] text-yellow-500">★</span>
                </h6>
                <h6
                  className="font-normal text-[12px] text-gray-400 leading-[18px] line-clamp-3 !mt-3"
                  style={{ fontFamily: "Inter" }}
                >
                  {item?.description}
                </h6>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default MobileCardListing;
